import { useEffect, useRef } from 'react'

export function useAutoFocus<T extends HTMLElement>(isOpen: boolean, delay = 100) {
  const ref = useRef<T>(null)

  useEffect(() => {
    if (!isOpen) return
    const timer = setTimeout(() => {
      const el = ref.current
      if (!el) return
      const focusable = el.querySelector<HTMLElement>(
        'input:not([type=hidden]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
      )
      if (focusable) focusable.focus()
    }, delay)
    return () => clearTimeout(timer)
  }, [isOpen, delay])

  return ref
}
